export default __webpack_public_path__ + "assets/images/5f410a0c0cb5a193bc4fd51c48e4a221.png";